import React from "react";
import '../views/formations-page.css'
import propTypes from 'prop-types';

const FooterFormation = (props) => {

    function downloadBrochure() {
		window.open("/brochures/" + props.downloadLink, '_blank');
	}

    return (
        <div className="div-certif-download">
            { props.downloadLink != "" &&(<div className="d-flex flex-column justify-content-center">
				<button onClick={downloadBrochure} className="btn btn-primary">Télécharger la brochure</button>
            </div>)}
            <div className="accessibility-note">
                <a href="/contact">
                    <img src="/image_accessiblite.png" alt="Accessibilité : pour toute adaptation liée à un handicap, contactez-nous afin que nous puissions organiser les aménagements nécessaires." style={{ maxWidth: "100%" }} />
                </a>
            </div>
        </div>
    )
}

FooterFormation.defaultProps = {
	downloadLink: "RE.pdf",
	nomFormation: "",
}

FooterFormation.propTypes = {
	downloadLink: propTypes.string,
	nomFormation: propTypes.string,
}

export default FooterFormation;